

































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit } from 'vue-property-decorator';
import { Watch } from 'vue-property-decorator';
import TicketFilter from './TicketFilter.vue';
import ticketsRepository from '@/modules/tickets/shared/repositories/tickets.repository';
import moment from 'moment';

@Component({
    components: {
        TicketFilter,
    },
})
export default class TicketDataTable extends Vue {
    @Prop({ required: true })
    headers!: {}[];

    @Prop({ required: true })
    items!: {}[];

    itemDetail: {
        name?: string;
        description?: string;
        creationDate?: string;
        closingDate?: string;
        contact?: {
            name?: string;
            lastName?: string;
            email?: string;
            ci?: string;
            phone?: string;
            cellphone?: string;
            position?: string;
        };
    } = {
        name: 'N/D',
        description: 'N/D',
        closingDate: 'N/D',
        contact: {},
    };

    @Prop()
    showDetails!: boolean;
    waitingForDetails: boolean = true;
    itemsPerPage: number[] = [10, 15, 20, 50, 100];
    loadingText: string = 'Obteniendo los tickets, espere un momento por favor';
    noDataText: string = 'No hay tickets disponibles.';
    dataLoad: boolean = true;
    search: string = '';
    filters: { id: number; name: string; type: string; color: string }[] = [];
    optionsTickets: any = {};

    @Emit('editItem')
    editItem(item: {}) {
        return item;
    }

    noDataDT() {
        if (this.items.length < 1) {
            setTimeout(() => {
                this.dataLoad = false;
            }, 8000);
        } else {
            this.dataLoad = false;
        }
    }

    getDate(date: string | Date, format?: string) {
        return moment(date)
            .lang('es')
            .format(format ? format : 'dddd, DD [de] MMMM [de] YYYY, hh:mm:ss a');
    }

    @Watch('optionsTickets.itemsPerPage')
    cambioTickets(value) {
        this.$emit('getItemsPerPage', value);
    }

    updated() {
        this.noDataDT();
    }

    @Emit('fireWarning')
    fireWarning(item: {}) {
        return item;
    }

    deleteItem(item: {}) {
        const index = this.items.indexOf(item);
        this.items.splice(index, 1);
    }

    dialog: boolean = false;
    closeDialog() {
        this.dialog = false;
    }

    openDialog() {
        this.$store.dispatch('getFilters');
        this.dialog = true;
    }

    getFiltersTicketMenu() {
        if (this.filters !== undefined) {
            return this.filters;
        } else {
            return [];
        }
    }

    setFilters(filters: { id: number; name: string; type: string; color: string }[]) {
        if (filters !== this.filters) {
            this.filters = filters;
            this.closeDialog();
            this.$emit('getFiltersTicketMenu', this.getFiltersTicketMenu());
        }
        this.closeDialog();
    }

    async openDetail(data: { item: { serial: number; type: string; date: Date; state: {} } }) {
        this.waitingForDetails = true;
        this.itemDetail = {
            name: '',
            description: 'Sin Descripción',
            creationDate: '',
            closingDate: '',
            contact: {},
        };

        try {
            let response = await ticketsRepository.getTicketById(data.item.serial);
            let info = response.data;

            this.itemDetail.name = info.name;
            this.itemDetail.creationDate = this.getDate(info.creationDate);
            this.itemDetail.closingDate =
                info.closingDate && info.closingDate !== ''
                    ? this.getDate(info.closingDate)
                    : 'Este ticket aún no ha sido cerrado.';

            this.itemDetail.contact = info.contact;
        } catch (err) {
            // No se hace nada...
        }

        this.waitingForDetails = false;
    }
}
